export let TextSearchListOpenUrl = "https://bs-dd-api-prototype.azurewebsites.net/api/TextSearchListOpen/v5";
export let PropertyUrl = "https://bs-dd-api-prototype.azurewebsites.net/api/Property/v2";
export let ClassificationUrl = "https://bs-dd-api-prototype.azurewebsites.net//api/Classification/v3";